<style scoped>
.col {
    width: 350px;
    overflow: hidden;
}
#auditGrid {
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: auto;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 5px;
    border-bottom: 2px solid #ccc;
    padding-bottom: 10px;
    padding-top: 10px;
}
</style>

<template>
    <h1 class="mt-5">Audit trail</h1>

    <div class="shadow sm:rounded-md mt-2">
        <div class="px-4 py-5 bg-white sm:p-6 relative">
            <div id="audits">
                <div v-for="audit in audits">
                    <div id="auditGrid">
                        <div class="col">
                            <div><strong>Date:</strong> {{ formatDate(audit.created_at) }}</div>
                            <div><strong>Event:</strong> {{ audit.event }}</div>
                            <div><strong>Url:</strong> {{ audit.url }}</div>
                            <div><strong>IP:</strong> {{ audit.ip_address }}</div>
                            <div><strong title="Id of an author of this change">Author id:</strong> {{ audit.user_id }}</div>
                            <div><strong>User agent:</strong> <span class="inline-block align-bottom truncate w-40">{{ audit.user_agent }}</span></div>
                        </div>
                        <div class="col">
                            <div><strong>Old values:</strong><br>
                                {{ audit.old_values }}</div>
                        </div>
                        <div class="col">
                            <div><strong>New values:</strong><br>
                                {{ audit.new_values }}</div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>


export default {
    props: {
        audits: Object
    },

    setup(props) {
        console.log(JSON.stringify(props.audits));
    }
}
</script>
